// eventBus.js
const listeners = {};

const eventBus = {
  on(event, callback) {
    (listeners[event] || (listeners[event] = [])).push(callback);
  },
  off(event, callback) {
    listeners[event] = (listeners[event] || []).filter(cb => cb !== callback);
  },
  emit(event, data) {
    (listeners[event] || []).forEach(cb => cb(data));
  }
};
export default eventBus;